import {useEffect, useState} from "react";
import {Autocomplete, TextField, CircularProgress, useTheme} from '@mui/material';

const ContainerStatusListDropdownComponent = (props) => {
    const {onChange, value, fullWidth, size, customStyles, disabled, isFetchingContainerStatusList, containerStatusList, getContainerStatusList} = props;

    const theme = useTheme();

    const [containerStatusListData, setContainerStatusListData] = useState([]);
    const [stateValue, setStateValue] = useState(null);
    const [inputValue, setInputValue] = useState("");

    
    useEffect(() => {
        getContainerStatusList();
    }, [])

    useEffect(() => {
        setStateValue(value || null);
        setInputValue(value || "");

        if (containerStatusList?.length > 0) {
            const filteredContainerStatusData = containerStatusList?.filter((status) => status !== value);

            setContainerStatusListData(filteredContainerStatusData);
        }
    }, [containerStatusList, value])


    const handleChange = (newValue) => {
        setStateValue(newValue);
        setInputValue(newValue || "");
        onChange(newValue);
    }

    
    return (
        <>
            <Autocomplete
                disabled={disabled ? disabled : false}
                disablePortal
                options={containerStatusListData}
                getOptionLabel={(option) => option || ""}
                isOptionEqualToValue={(option, value) => option === value}
                fullWidth={fullWidth}
                size={size}
                value={stateValue}
                loading={isFetchingContainerStatusList}
                onChange={(event, newValue) => handleChange(newValue)}
                inputValue={inputValue}
                onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
                noOptionsText="Status not found."
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Search container status"
                        slotProps={{
                            input: {
                            ...params.InputProps,
                            endAdornment: (
                                <>
                                    {isFetchingContainerStatusList ? <CircularProgress color="inherit" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                </>
                            ),
                        }}}
                        sx={{
                            '& .MuiOutlinedInput-root': {
                                borderRadius: "4px", 
                                height: "42px",
                                paddingTop: '6px', 

                                '& input': {
                                    color: theme.typography.main,
                                    fontSize: 16,
                                    fontWeight: 500,

                                    '&::placeholder': {
                                        color: theme.typography.secondary,               
                                        opacity: 0.45,    
                                        fontSize: 15,    
                                        fontWeight: "400 !important",                     
                                    },
                                },

                                '& fieldset': {
                                    borderColor: "#e5edf6",
                                },

                                '&:hover fieldset': {
                                    borderColor: "#e5edf6",
                                },

                                '&.Mui-focused fieldset': {
                                    borderColor: "#253e5a9e",
                                },
                            },
                            '& .MuiInputLabel-root': {
                                color: theme.typography.secondary,               
                                opacity: 0.45,    
                                fontSize: 15,    
                                fontWeight: "400 !important",
                                marginTop: "-5px",
                            },
                        }}
                    />
                )}
                sx={{...customStyles}}
            />
        </>
    )
}

export default ContainerStatusListDropdownComponent